import { toast } from "sonner";

export const SOCIALS = [
  ["Facebook", "https://www.facebook.com/emmaindustrie", "M14 8.5V6.6c0-.9.6-1.1 1-1.1h2.6V1.6L14 1.6c-4 0-4.9 3-4.9 4.9v2H6.8v4h2.3V22.4H14V12.5h3.3l.4-4z"],
  ["Instagram", "https://www.instagram.com/emma_industrie/", "M12 2.2c3.2 0 3.6 0 4.8.1 3.3.1 4.8 1.7 4.9 4.9.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 3.2-1.7 4.8-4.9 4.9-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-3.3-.1-4.8-1.7-4.9-4.9C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8C2.4 3.9 3.9 2.4 7.2 2.3 8.4 2.2 8.8 2.2 12 2.2zm0 4.8a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm5.2-9.6a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z"],
  ["LinkedIn", "https://www.linkedin.com/company/103659570/", "M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z"],
];
const PAUSED = ["LinkedIn"]; // momentaneamente scollegato: togli il nome per riattivarlo
const icon = (name) => SOCIALS.find(([n]) => n === name)[2];
const Icon = ({ name }) => <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true"><path d={icon(name)} /></svg>;

// Facebook + Instagram share buttons for a product or project card.
// Instagram has no web share link: phones open the share sheet (Instagram included), computers copy the link and open Instagram.
export const SocialShare = ({ url, text, t, btn, id }) => {
  const insta = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: text, text, url }); } catch { /* user closed the share sheet */ }
      return;
    }
    try { await navigator.clipboard.writeText(url); } catch { /* clipboard blocked: link shown in the toast */ }
    toast.success(t("share.igCopied", "Link copiato: incollalo nel tuo post o nella tua storia Instagram"), { description: url });
    window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" className={btn} data-testid={`${id}-share-facebook`}><Icon name="Facebook" /> Facebook</a>
      <button type="button" onClick={insta} className={btn} data-testid={`${id}-share-instagram`}><Icon name="Instagram" /> Instagram</button>
    </>
  );
};

export const SocialLinks = ({ className = "", btnClass = "border-current" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="social-links">
    {SOCIALS.filter(([name]) => !PAUSED.includes(name)).map(([name, href, d]) => (
      <a
        key={name}
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label={`Emma Industrie su ${name}`}
        className={`grid h-11 w-11 place-items-center rounded-full border transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#121110] hover:text-[#F7F5F0] ${btnClass}`}
        data-testid={`social-${name.toLowerCase()}`}
      >
        <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden="true"><path d={d} /></svg>
      </a>
    ))}
  </div>
);
